import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select.tsx";
import { cn } from "@/lib/utils.ts";
import { usaTimezones } from "@/lib/utils/timezone";

interface TimezoneSelectProps {
  value: string;
  onChange: (value: string) => void;

  triggerClassName?: string;
  contentClassName?: string;
}

export function TimezoneSelect({
  value,
  onChange,
  triggerClassName,
  contentClassName,
}: TimezoneSelectProps) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={cn("w-[280px]", triggerClassName)}>
        <SelectValue placeholder="Select a timezone" />
      </SelectTrigger>
      <SelectContent className={contentClassName}>
        {usaTimezones.map((timezone) => (
          <SelectItem key={timezone} value={timezone}>
            {timezone}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
